export default __webpack_public_path__ + "static/media/mob-landing.63a95d70.svg";